export interface LastUsedRoomIssue {
  id?: number;
  lotAreaIdentifier?: string;
  deleted?: 0 | 1;
}

/** Returns the room from the most recently created issue that has an assigned room. */
export function resolveLastUsedRoomFromIssues(
  issues: ReadonlyArray<LastUsedRoomIssue>
): string | undefined {
  const assigned = issues.filter(issue => !issue.deleted && !!issue.lotAreaIdentifier);
  if (assigned.length === 0) {
    return undefined;
  }

  assigned.sort((a, b) => (b.id ?? 0) - (a.id ?? 0));
  return assigned[0].lotAreaIdentifier;
}
